import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

export function GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        '*': {
          margin: 0,
          padding: 0,
          outline: 0,
          boxSizing: 'border-box',
        },
        '*:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
        'html, body, #root': {
          width: '100%',
          minHeight: '100%',
        },
        body: {
          WebkitFontSmoothing: 'antialiased !important',
        },
        img: {
          pointerEvents: 'none !important',
          userSelect: 'none !important',
          WebkitUserDrag: 'none !important',
          WebkitUserSelect: 'none !important',
          MozUserSelect: 'none !important',
          msUserSelect: 'none !important',
        },
        'a, button': {
          WebkitTapHighlightColor: 'transparent !important',
        },
        '@keyframes fadeIn': {
          from: { opacity: 0.6 },
          to: { opacity: 1 },
        },
      })}
    />
  );
}
